import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function GroupCreateWalletsCountText(t0) {
  const $ = _c(6);
  const {
    loading,
    walletsCount
  } = t0;
  if (loading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="tw-text-iron-50 tw-font-semibold">Loading...</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (typeof walletsCount === "number") {
    let t1;
    if ($[1] !== walletsCount) {
      t1 = formatNumberWithCommas(walletsCount);
      $[1] = walletsCount;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== t1) {
      t2 = <span className="tw-text-primary-400 tw-font-semibold">{t1}</span>;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-text-iron-400 tw-font-medium">Not added</span>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}